<template>
  <!--面包屑-->
  <div class="place">
    <span>位置：</span>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        v-for="(item, index) in menu.crumbs"
        :key="index">
        {{ getText(item) }}
      </el-breadcrumb-item>
      <template v-if="!crm_id">
        <el-breadcrumb-item
          v-for="(item, index) in appendData"
          :key="`append-${index}`">
          {{ getText(item) }}
        </el-breadcrumb-item>
      </template>
      <el-breadcrumb-item v-else-if="crm_id">
        {{ getText(custom_name) }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  name: 'JmCrumbs',
  props: {
    append: [Array, String],
    crm_id: {
      type: [Number, String],
      default: null
    },
  },
  data() {
    return {
      custom_name: null,
    };
  },
  methods: {
    getText(text) {
      return this.isInterviewSite ? this.$t(text) : text;
    },
    getCustomName() {
      this.$http
        ._post({
          url: '/index/student/getCustomName',
          data: { crm_id: this.crm_id }
        })
        .then(({ data }) => {
          this.custom_name = data;
        });
    },
  },
  mounted() {
    if (this.crm_id) {
      this.getCustomName();
    }
  },
  computed: {
    ...mapState(['menu']),
    appendData() {
      if (Array.isArray(this.append)) {
        return this.append;
      }
      return [this.append];
    }

  },
};
</script>
<style scoped>
.place {
  line-height: 32px;
  padding-bottom: 5px;
}
.place::after{
  clear: both;
  display: block;
  content: "";
}
.place span {
  float: left;
  font-size: 12px;
  color: #666 !important;
}

.place > span:hover {
  color: #666 !important;
}

.el-breadcrumb {
  line-height: inherit !important;
}

</style>
